module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Solicitações'
    }
  }), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" BAIXANDO ARQUIVO... " + _vm._s(_vm.$route.params.id))])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-centered overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download prest-scale"
  }), _vm._v("\n        Aguarde...\n   ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39e4d47c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/downloadArquivoPrestacao.vue
// module id = 1865
// module chunks = 2